import React, { MouseEventHandler } from "react"

import { useGlobalSearchContext } from "../../context/GlobalSearchContext"
import { MediumLoadingIndicator } from "../LoadingIndicator/LoadingIndicator"

import Styles from "./RenderSearch.module.css"

const Search = React.lazy(
	() =>
		import(
			/*
		webpackChunkName: "global-search"
	 */
			"./Search"
		)
)

const preventBubble: MouseEventHandler = (event) => {
	event.stopPropagation()
}
const RenderSearch: React.FC = () => {
	const { active, closeSearch } = useGlobalSearchContext()

	if (!active) {
		return null
	}

	return (
		<div onClick={closeSearch} className={Styles.overlay}>
			<div className={Styles.container} onClick={preventBubble}>
				<React.Suspense fallback={<MediumLoadingIndicator />}>
					<Search />
				</React.Suspense>
			</div>
		</div>
	)
}

export default RenderSearch
